<template>
    <div>

        <!-- Faq Section Start -->
        <section class="faq-box-contain section-b-space">
            <div class="container">
                <div class="row">
                    <div class="col-xl-5">
                        <div class="faq-contain">
                            <h2>{{ $t('Frequently Asked Questions')}}</h2>
                            <p>
                                {{ $t('We are answering most frequent questions. No worries if you not find exact one. You can find out more by searching or continuing clicking button below or')}}

                                <router-link
                                    :to="{name: 'contact_us.create' ,  params: {  lang : $i18n.locale }}"
                                    class="theme-color text-decoration-underline "> {{ $t('directly contact our support')}}  </router-link>
                            </p>
                        </div>
                    </div>

                    <div class="col-xl-7">
                        <div class="faq-accordion">
                            <div class="accordion" id="accordionExample">

                                <div class="accordion-item"  v-for="item in items?.data">
                                    <h2 class="accordion-header" :id="'heading'+ item.id">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                :data-bs-target="'#collapse'+ item.id" aria-expanded="false"
                                                :aria-controls="'collapse'+ item.id">
                                            {{ item.question }}
                                            <i class="fa-solid fa-angle-down"></i>
                                        </button>
                                    </h2>
                                    <div :id="'collapse'+ item.id" class="accordion-collapse collapse"
                                         :aria-labelledby="'heading'+ item.id"
                                         data-bs-parent="#accordionExample">
                                        <div class="accordion-body"  v-html="item?.answer"></div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Faq Section End -->
    </div>
</template>

<script>

import { Bootstrap5Pagination } from 'laravel-vue-pagination'
// import Apptoast from "../handling/toast";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
    components:{
        Bootstrap5Pagination
    },
    data() {
        return {
            items: [],
            q: this.$route.query,
            form_options: {},
        }
    },
    created() {
        this.getResults();
    },
    methods: {
        getResults ( page = this.$route?.query?.page ?? 1 ) {

            const id = toast.info( this.$t('Getting content ...'),{ icon: 'fa-solid fa-download' });

            axios.get('faqs', { params : { 'page' : page, }} ).then(response => {
                toast.dismiss(id);
                this.items = response.data;

            }, response => {
                toast.dismiss(id);
            });

        },
        delete(id) {

            axios.delete(`faqs/${id}`)
                .then(response => {
                    let i = this.items.map(item => item.id).indexOf(id);
                    this.items.splice(i, 1)
                });
        }
    }
}
</script>
